// context/TestsContext.js
import { getTestsByOwner } from "../../Backend/fetchTest";
import { createContext,useCallback, useState, useRef, useContext } from "react";


const TestsContext = createContext();

export function TestsProvider({ children }) {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchedRef = useRef(false); // prevents double-fetch in StrictMode

  const loadTests = useCallback(async (ownerId) => {
    if (fetchedRef.current) return; // already fetched, skip
    fetchedRef.current = true;
    setLoading(true);
    try {
      console.log("load test called");
      const data = await getTestsByOwner(ownerId);
      setTests(data);
    } finally {
      setLoading(false);
    }
  }, []);

  const invalidate = () => {
    console.log("current test data invalidated");
    fetchedRef.current = false; // call this after creating a new test
  };

  return (
    <TestsContext.Provider value={{ tests, loading, loadTests, invalidate }}>
      {children}
    </TestsContext.Provider>
  );
}

export const useTests = () => useContext(TestsContext);